import type { OrderCardData } from '@chewy/chat-library-common';
import styles from './Thumbnail.module.scss';
import { WidgetContainer, NavLink, ActionButton } from '@chewy/chat-library-components';
import first from 'lodash/first';
import { ProductImage } from '.';

interface ThumbnailProps {
  data: OrderCardData;
  isSelectable?: boolean;
  isSelected?: boolean;
  isUnselected?: boolean;
  onSelect?: () => void;
}

export default function Thumbnail({ data, isSelectable = false, isSelected, isUnselected, onSelect }: ThumbnailProps) {
  const item = first(data.items);
  const actions = data.actions ?? [];
  const hasActions = actions.length > 0;

  const nonLinkActions = actions.filter((action) => action.type !== 'link');
  const linkActions = actions.filter((action) => action.type === 'link');
  const firstLinkAction = first(linkActions);

  return (
    <WidgetContainer
      isSelectable={isSelectable}
      isSelected={isSelected}
      isUnselected={isUnselected}
      onSelect={onSelect}
      hasActions={hasActions}
      data={data}
    >
      <div className={styles.thumbnail}>
        <div
          className={`${styles.imageWrapper}`}
        >
          <ProductImage
            imageUrl={item?.imageUrl || ''}
            name={item?.name || 'Order item'}
            quantity={item?.quantity}
          />
          {firstLinkAction && (
            <NavLink
              href={firstLinkAction.url || ''}
              label={firstLinkAction.text || ''}
              action={firstLinkAction}
              widgetData={data}
            />
          )}
        </div>

        {nonLinkActions.length > 0 && (
          <div className={styles.actionsContainer}>
            {nonLinkActions.map((action, index) => (
              <ActionButton key={index} action={action} widgetData={data} />
            ))}
          </div>
        )}
      </div>
    </WidgetContainer>
  );
}
